export const getCallFocusCheckboxes = (
  options,
  checkBoxHandler,
  isDisabled = false,
  formikProps = {},
) => {
  return (
    <>
      {Object.entries(options)
        .sort()
        .map(([optionKey, optionValue]) => {
          return (
            <div className="custom-control custom-checkbox col-12 col-lg-4" key={optionKey}>
              <input
                checked={options[optionKey] ? optionValue : null}
                className="custom-control-input"
                disabled={isDisabled ? "disabled" : null}
                id={optionKey}
                name={optionKey}
                onClick={() => {
                  checkBoxHandler(options, optionKey, formikProps);
                }}
                type="checkbox"
              />

              <label className="custom-control-label" htmlFor={optionKey}>
                <span>{optionKey}</span>
              </label>
            </div>
          );
        })}
    </>
  );
};
